export default __webpack_public_path__ + "static/media/david.6283648e.jpg";